export default function addDaysToDate(date, days) {
  let result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/addDaysToDate', addDaysToDate);